export default __webpack_public_path__ + "side_channels.png";